const ClassificationEmptyState = ({
    message = '👋 Hej! Du har inga klassificeringar än. Skapa en ny klassificering genom att trycka på knappen nedan. 💫🌍',
    linkComponent,
    className = 'districts__no-hits'
}) => (
    <div className={className}>
        <p>{message}</p>
        {linkComponent}
    </div>
);

export default ClassificationEmptyState;

